<template>
  <div>
    <h2>{{ $t("pages.wording.systemSwitch") }}</h2>
    <div>
      <h3>{{ $t("pages.wording.jitScheduler") }}</h3>
      <el-switch
        v-model="jit"
        :active-text="$t('pages.wording.systemOn')"
        :inactive-text="$t('pages.wording.systemOff')"
        @change="updateJIT"
      >
      </el-switch>
    </div>
    <div>
      <h3>WJ{{ $t("pages.wording.guardRoasterController") }}</h3>
      <el-switch
        v-model="guardshiftWJ"
        :active-text="$t('pages.wording.systemOn')"
        :inactive-text="$t('pages.wording.systemOff')"
        @change="updateGuardshiftWJ"
      >
      </el-switch>
    </div>
    <div>
      <h3>WH{{ $t("pages.wording.guardRoasterController") }}</h3>
      <el-switch
        v-model="guardshiftWH"
        :active-text="$t('pages.wording.systemOn')"
        :inactive-text="$t('pages.wording.systemOff')"
        @change="updateGuardshiftWH"
      >
      </el-switch>
    </div>
    <hr />
    <h2>{{ $t("pages.wording.scheduler") }}</h2>
    <div>
      <h3>{{ $t("pages.wording.jitScheduler") }}</h3>
      <el-input v-model="schedule.jitRunDate" :placeholder="$t('pages.wording.executeDateFormat')"></el-input>
      <el-button class="blue-button" @click="runJIT" type="primary">{{ $t("pages.button.execute") }}</el-button>
    </div>
    <hr />
    <h2>{{ $t("pages.wording.reserveStatus") }}</h2>
    <div>
      <el-form :rules="rules" ref="ruleForm" :model="reserve.query" label-width="120px">
        <div class="boxContain c-form searchBar">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item :label="$t('pages.wording.reserveNo')" prop="reserveNo"
                ><!--單號-->
                <el-input
                  v-model.trim="reserve.query.reserveNo"
                  :placeholder="$t('pages.wording.placeholderInput')"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button @click="queryReserveInfoByReserveNo" type="primary">{{ $t("pages.button.search") }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div>
      <h3>{{ this.$t("pages.wording.reserveTitle") + " " + this.$t("pages.wording.searchResult") }}</h3>
      <el-table v-if="reserve.reserveData.length > 0" :data="reserve.reserveData" border style="width: 100%">
        <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')"></el-table-column>
        <el-table-column prop="reserveType" :label="$t('pages.wording.reserveType')" width="100"> </el-table-column>
        <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')"></el-table-column>
        <el-table-column prop="reserveArriveDate" :label="$t('pages.wording.reserveArriveDate')">
          <template slot-scope="scope">
            {{
              scope.row.reserveArriveDatetime != null
                ? formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime)
                : "NA"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="reserveStatus" :label="$t('pages.wording.reserveStatus')" width="160">
          <template slot-scope="scope">
            <el-select v-model="scope.row.reserveStatus" :placeholder="$t('pages.wording.placeholderSelect')">
              <el-option :label="$t('reserve.status.cancel')" value="cancel"></el-option
              ><!--取消-->
              <el-option :label="$t('reserve.status.temporary')" value="temporary"></el-option
              ><!--暫存-->
              <el-option :label="$t('reserve.status.vendorComfirm')" value="vendorComfirm"></el-option
              ><!--待廠商確認-->
              <el-option :label="$t('reserve.status.entering')" value="entering"></el-option
              ><!--待進廠檢查-->
              <el-option :label="$t('reserve.status.in1')" value="in1"></el-option
              ><!--待出廠初檢-->
              <el-option :label="$t('reserve.status.in2')" value="in2"></el-option
              ><!--待出廠複檢-->
              <el-option :label="$t('reserve.status.finished')" value="finished"></el-option
              ><!--已完成-->
              <el-option :label="$t('reserve.status.enteringFail')" value="enteringFail"></el-option
              ><!--進廠檢查不合格-->
            </el-select>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button @click="updateReserveStatus(scope.row)" type="primary">{{
              $t("pages.wording.updateStatus", { 0: $t("pages.wording.reserveTitle") })
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <h3>{{ this.$t("pages.wording.releaseOrder") + " " + this.$t("pages.wording.searchResult") }}</h3>
      <el-table v-if="reserve.releaseData.length > 0" :data="reserve.releaseData" border style="width: 100%">
        <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')"> </el-table-column>
        <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')"> </el-table-column>
        <el-table-column prop="releaseOrderStatus" :label="$t('pages.wording.releaseOrderStatus')">
          <template slot-scope="scope">
            <el-select v-model="scope.row.releaseOrderStatus" :placeholder="$t('pages.wording.placeholderSelect')">
              <el-option
                v-for="item in options.releaseStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button @click="updateReleaseStatus(scope.row)" type="primary">{{
              $t("pages.wording.updateStatus", { 0: $t("pages.wording.releaseOrder") })
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
export default {
  name: "AdminMaintain",
  data() {
    return {
      jit: false,
      guardshiftWJ: false,
      guardshiftWH: false,
      schedule: {
        jitRunDate: null,
      },
      reserve: {
        query: {
          reserveNo: null,
        },
        reserveData: [],
        releaseData: [],
      },
      rules: {
        reserveNo: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
      },
      options: {
        releaseStatus: [
          {
            label: this.$t("release.status.NEW"),
            value: "NEW",
          },
          {
            label: this.$t("release.status.sign"),
            value: "sign",
          },
          {
            label: this.$t("release.status.in1"),
            value: "in1",
          },
          {
            label: this.$t("release.status.in2"),
            value: "in2",
          },
          {
            label: this.$t("release.status.finished"),
            value: "finished",
          },
          {
            label: this.$t("release.status.cancel"),
            value: "cancel",
          },
        ],
      },
    }
  },
  created() {
    this.getSystemSetting("ActiveJITJob", "jit")
    this.getSystemSetting("guardshift-WJ", "guardshiftWJ")
    this.getSystemSetting("guardshift-WH", "guardshiftWH")
  },
  methods: {
    getSystemSetting(name, dataObjName) {
      let parameter = {
        name: name,
      }
      api
        .apiGetSystemSettingValue({ params: parameter })
        .then((response) => {
          this[dataObjName] = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateJIT(val) {
      this.updateSystemSetting("ActiveJITJob", val)
    },
    updateGuardshiftWJ(val) {
      this.updateSystemSetting("guardshift-WJ", val)
    },
    updateGuardshiftWH(val) {
      this.updateSystemSetting("guardshift-WH", val)
    },
    runJIT() {
      const vueInstance = this
      const parameter = {
        runDate: this.schedule.jitRunDate,
      }
      vueInstance
        .$confirm(vueInstance.$t("message.alert.confirmJitExecuteDate"), { 0: this.schedule.jitRunDate })
        .then((_) => {
          api
            .apiRunJITAutoReserve({ params: parameter })
            .then((response) => {
              vueInstance.$message({
                message: vueInstance.$t("message.title.success"),
                type: "success",
              })
            })
            .catch((error) => {
              vueInstance.$message({
                message: error.response.data,
                type: "error",
              })
              console.log(error)
            })
        })
    },
    updateSystemSetting(name, value) {
      let vueInstance = this
      let parameter = {
        name: name,
        value: value,
      }
      api
        .apiUpdateSystemSettingValue({ params: parameter })
        .then(() => {
          vueInstance.$message({
            message: vueInstance.$t("message.alert.successUpdate"),
            type: "success",
          })
        })
        .catch((error) => {
          console.log(error)
          vueInstance.$message({
            message: error,
            type: "error",
          })
        })
    },
    queryReserveInfoByReserveNo() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) {
          return
        }
        let vueInstance = this
        let parameter = {
          reserveNo: vueInstance.reserve.query.reserveNo,
        }
        api
          .apiGetQueryReserveTable(parameter)
          .then((response) => {
            vueInstance.reserve.reserveData = response.data.result
            if (vueInstance.reserve.reserveData !== null) {
              let releaseParam = {
                reserveRef: vueInstance.reserve.reserveData[0].id,
              }
              api
                .apiGetReleaseTable(releaseParam)
                .then((response) => {
                  vueInstance.reserve.releaseData = response.data.result
                })
                .catch(function (e) {})
            }
          })
          .catch(function (e) {})
      })
    },
    updateReserveStatus(data) {
      let vueInstance = this
      if (data.reserveStatus == null || data.reserveStatus == "") {
        this.$message({
          message: vueInstance.$t("message.alert.reserveStatusRequired"),
          type: "error",
        })
        return
      }
      let parameter = {
        id: data.id,
        resStatus: data.reserveStatus,
      }
      api
        .apiUpdataReserveStatus({ params: parameter })
        .then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: "Success",
              type: "success",
            })
          }
        })
        .catch(function (e) {})
    },
    updateReleaseStatus(data) {
      let vueInstance = this
      if (data.releaseOrderStatus == null || data.releaseOrderStatus == "") {
        this.$message({
          message: vueInstance.$t("message.alert.releaseStatusRequired"),
          type: "error",
        })
        return
      }
      let parameter = {
        releaseID: data.id,
        updateReleaseStatus: data.releaseOrderStatus,
      }
      api
        .apiUpdateReleaseStatusByReleaseID({ params: parameter })
        .then((response) => {
          if (response.data) {
            this.$message({
              message: "Success",
              type: "success",
            })
          }
        })
        .catch(function (e) {})
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
}
</script>
